import { HTMLProps, useRef } from 'react'

// import { IconMenu } from '~/components/icons/IconMenu'

// import PMCWide from '/images/logo/pmc-wide.svg?url'
import cn from 'classnames'
// import { IconPWLogo } from '~/components/icons/IconPWLogo'
// import { Link } from '@tanstack/react-router'

export function Header ({ className, ...props }: HTMLProps<HTMLDivElement>)
{
    const drawerCheck = useRef<HTMLInputElement>(null)

    const items = [{
        href: '#cryptocurrencies',
        text: 'Cryptocurrencies',
    }, {
        href: '#about',
        text: 'About',
    }, {
        href: '#privacy-methods',
        text: 'Privacy Methods',
    }]

    return (
        <div className={cn(className)} {...props}>
            {/*<div className="drawer">*/}
            {/*    <input id="my-drawer-3" type="checkbox" className="drawer-toggle" ref={drawerCheck} />*/}
            {/*    <div className="drawer-content">*/}
            {/*        <header*/}
            {/*            className={cn(*/}
            {/*                'w-full flex items-center py-3',*/}
            {/*                'md:border-b border-dashed border-accent/40',*/}
            {/*                className,*/}
            {/*            )}*/}
            {/*        >*/}
            {/*            <Link to={'/'}>*/}
            {/*                <IconPWLogo className={cn('h-7.5 w-43.5')} />*/}
            {/*            </Link>*/}

            {/*            <nav className="hidden flex-none ms-auto md:block">*/}
            {/*                <ul className="flex flex-row items-center gap-8">*/}
            {/*                    {items.map((item, index) => (*/}
            {/*                        <li key={index}>*/}
            {/*                            <a href={item.href} className={'px-4 py-2'}>{item.text}</a>*/}
            {/*                        </li>*/}
            {/*                    ))}*/}
            {/*                </ul>*/}
            {/*            </nav>*/}
            {/*            <nav className="flex-none ms-auto md:hidden">*/}
            {/*                <label htmlFor="my-drawer-3" aria-label="Open sidebar">*/}
            {/*                    <IconMenu className={cn('inline-block h-6 w-6')} />*/}
            {/*                </label>*/}
            {/*            </nav>*/}
            {/*        </header>*/}
            {/*    </div>*/}

            {/*    <div className="drawer-side z-100">*/}
            {/*        <label htmlFor="my-drawer-3" aria-label="Close sidebar" className="drawer-overlay"></label>*/}
            {/*        <ul className="flex flex-col gap-2 min-h-full max-w-80 min-w-60 px-4 py-2 bg-base-100">*/}
            {/*            {items.map((item, index) => (*/}
            {/*                <li key={index}>*/}
            {/*                    <a href={item.href} className={'block px-4 py-2'} onClick={() => drawerCheck.current && (drawerCheck.current.checked = false)}>{item.text}</a>*/}
            {/*                </li>*/}
            {/*            ))}*/}
            {/*        </ul>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    )
}